import { createSlice } from '@reduxjs/toolkit';
import {
  calculateOrderExchange,
  createOrder,
  getEditOrder,
  getOrders,
  getOrderStatus,
  getPollingEditOrder,
} from './orders.actions';

const initialState = {
  orders: [],
  ordersMeta: {},
  isLoadingOrders: false,

  selectedOrder: {},
  isLoadingOrder: false,

  errors: {},

  calculatedExchange: {},
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrdersMeta: (state, action) => {
      state.ordersMeta = action.payload;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setOrderErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state) => {
      state.isLoadingOrders = true;
    });
    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.orders = action.payload;
      state.isLoadingOrders = false;
    });
    builder.addCase(getOrders.rejected, (state) => {
      state.isLoadingOrders = false;
    });

    builder.addCase(createOrder.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(createOrder.fulfilled, (state) => {
      state.isLoadingOrder = false;
    });
    builder.addCase(createOrder.rejected, (state) => {
      state.isLoadingOrder = false;
    });

    builder.addCase(getEditOrder.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(getEditOrder.fulfilled, (state, action) => {
      state.selectedOrder = action.payload;
      state.isLoadingOrder = false;
    });
    builder.addCase(getEditOrder.rejected, (state) => {
      state.isLoadingOrder = false;
    });

    builder.addCase(getPollingEditOrder.fulfilled, (state, action) => {
      state.selectedOrder = { ...state.selectedOrder, ...action.payload };
    });

    builder.addCase(getOrderStatus.pending, (state) => {
      state.isLoadingOrder = true;
    });
    builder.addCase(getOrderStatus.fulfilled, (state, action) => {
      state.selectedOrder = action.payload;
      state.isLoadingOrder = false;
    });
    builder.addCase(getOrderStatus.rejected, (state) => {
      state.isLoadingOrder = false;
    });

    builder.addCase(calculateOrderExchange.pending, (state) => {});
    builder.addCase(calculateOrderExchange.fulfilled, (state, action) => {
      state.calculatedExchange = action.payload;
    });
    builder.addCase(calculateOrderExchange.rejected, (state) => {});
  },
});

export const { setOrdersMeta, setSelectedOrder, setOrderErrors } = ordersSlice.actions;

export default ordersSlice.reducer;
